import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/secure/')({
  beforeLoad: () => {
    throw redirect({ to: '/secure/login' });
  },
});
